<template>
  <div
    class="home-header"
    :style="themeStyle"
  >

    <div
      v-if="logo"
      id="header-title"
      class="header-title"
    >
      <router-link :to="{name: 'home'}">
        <vue-load-image>
          <b-img
            slot="image"
            :src="logo.image"
            fluid
            alt="logo"
          />
          <b-img
            slot="preloader"
            :src="require('@/assets/images/items/loading-2.png')"
            height="60"
            alt="logo"
          />
        </vue-load-image>
      </router-link>
    </div>

    <b-container class="header-container">
      <div class="header-navbar">
        <div
          v-if="linkbar"
          class="linkbar"
        >
          <b-img
            :src="linkbar.image"
            fluid
            alt="linkbar"
          />
        </div>
        <div class="crossbar">
          <div class="linkListbar">
            <ul
              v-for="linkUrl, index in configData.navbar.linkUrl"
              :key="index"
            >
              <li
                v-for="link, linkIndex in linkUrl.link"
                :key="linkIndex"
              >
                <a :href="link.url">
                  {{ link.title }}
                </a>
              </li>
            </ul>

          </div>
          <b-img
            v-if="crossbar"
            :src="crossbar.image"
            fluid
            alt="crossbar"
            class="bottom-bar"
          />
        </div>
      </div>
      <div
        v-if="configData.base.download && configData.base.download.show"
        class="download-btn"
      >
        <template-button :btn-config="configData.base.download" />
      </div>
    </b-container>
    <div
      class="navbar-button"
      @click="showNavbar"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="#ffffff"
      >
        <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z" />
      </svg>
    </div>
    <div
      class="navbar"
      :class="{ 'active': navbarShow }"
      :style="navbarBackground"
    >
      <div
        v-if="logo"
        class="navbar-logo"
      >
        <b-img
          :src="logo.image"
          fluid
          alt="logo"
        />
      </div>
      <div
        v-for="linkUrl, index in configData.navbar.linkUrl"
        :key="index"
        class="navbar-item"
      >
        <div
          ref="nav-item"
          class="navbar-link"
          @click="selectNavbar(index)"
        >
          <div>
            {{ linkUrl.name }}
          </div>
          <svg
            height="32"
            width="32"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            class="arrow"
          >
            <g
              id="Layer_43"
              data-name="Layer 43"
            >
              <path d="m25.33 11.49a2 2 0 0 0 -1.84-1.23h-.23l-6.72 1.57a2.46 2.46 0 0 1 -1.08 0l-6.72-1.55h-.23a2 2 0 0 0 -1.84 1.23 2 2 0 0 0 .43 2.18l7.49 7.49a2 2 0 0 0 2.82 0l7.49-7.49a2 2 0 0 0 .43-2.2zm-9.33 8.25-7.45-7.45 6.45 1.51a4.27 4.27 0 0 0 2 0l6.46-1.5z" />
            </g>
          </svg>
        </div>
        <ul
          ref="navLinks"
          class="navLinks"
          :class="{show: selected === index}"
        >
          <li
            v-for="link, linkIndex in linkUrl.link"
            :key="linkIndex"
            class="navLink"
          >
            <a :href="link.url">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { BContainer, BImg } from 'bootstrap-vue'
import VueLoadImage from 'vue-load-image'
import TemplateButton from './TemplateButton.vue'

export default {
  components: {
    BContainer,
    BImg,
    VueLoadImage,
    TemplateButton,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: -1,
      navbarShow: false,
      logo: null,
      linkbar: null,
      crossbar: null,
      navbarBackground: null,
      themeStyle: null,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  mounted() {
    this.themeStyle = [this.configData.base.config, this.configData.navbar.config]
    this.setbackgroundImage()
  },
  methods: {
    // (網頁)跳轉
    redirectLink(link) {
      if (!link) return
      window.location.assign(link)
    },
    showNavbar() {
      this.navbarShow = !this.navbarShow
      this.$emit('control-scroll')
    },
    selectNavbar(index) {
      if (this.selected !== -1) this.$refs['nav-item'][this.selected].classList.toggle('active')
      this.selected = this.selected === index ? -1 : this.selected = index
      if (this.selected !== -1) this.$refs['nav-item'][index].classList.add('active')
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    setbackgroundImage() {
      this.navbarBackground = {}
      this.logo = {}
      this.linkbar = {}
      this.crossbar = {}
      if (this.configData.base.logo && this.configData.base.logo.image) {
        this.logo.image = `${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.base.logo.image) : this.configData.base.logo.image}`
      }
      if (this.configData.navbar.linkbar && this.configData.navbar.linkbar.image) {
        this.linkbar.image = `${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.navbar.linkbar.image) : this.configData.navbar.linkbar.image}`
      }
      if (this.configData.navbar.crossbar && this.configData.navbar.crossbar.image) {
        this.crossbar.image = `${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.navbar.crossbar.image) : this.configData.navbar.crossbar.image}`
      }
      if (this.configData.navbar.background && this.configData.navbar.background.image) {
        this.navbarBackground.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.navbar.background.image) : this.configData.navbar.background.image})`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$background-color : var(--background-color);
$text-color : var(--text-color);
.home-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 200px;
  height: calc(var(--header-height) * 1vh);
}
.header-title {
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(0,-50%);
}
.header-container {
  position: relative;
  height: 100%;
  .header-navbar {
    position: absolute;
    right: 0;
    top: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
}
.linkbar {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 700px;
  height: 60px;
}
.crossbar {
  position: absolute;
  z-index: 1;
  top: 30px;
  left: 50%;
  max-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  transform: translateX(-50%);
  transition: .5s;
}
.linkListbar {
  margin: 20px 0;
  padding-top: 15px;
  height: auto;
  width: 100%;
  max-width: 600px;
  display: flex;
  background-color: $background-color;
  ul {
    flex: 1;
    margin-left: 24px;
    padding: 0;
    list-style-type: none;
    li {
      text-align: center;
      margin-bottom: 6px;
    }
    a {
      font-size: 14px;
      color: var(--text-color);
    }
  }
}
.bottom-bar {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}
.download-btn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.linkbar:hover + .crossbar {
  max-height: 500px;
}
.crossbar:hover {
  max-height: 500px;
}
.navbar {
  position: fixed;
  z-index: 1000;
  top: -100%;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  background-color: #000a;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: auto;
  transition: .6s;
  padding: 0;
  &.active {
    top: 0;
  }
}
.navbar-logo {
  height: 150px;
  img {
    height: 150px;
  }
}
.navbar-button {
  position: fixed;
  z-index: 1001;
  top: 20px;
  right: 10px;
  width: 50px;
  height: 50px;
  padding: 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.navbar-item {
  width: 100%;
  font-size: 20px;
  // border-top: $background-color 1px solid;
  // border-bottom: $background-color 1px solid;
  .navbar-link {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 25px 36px;
    color: $text-color;
    .arrow {
      fill: $text-color;
      transform: rotate(0);
      transition: transform .3s;
    }
    &.active {
      .arrow {
        transform: rotate(-180deg);
      }
    }
  }
  .navLinks {
    height: 0;
    background: $background-color;
    margin: 0;
    padding: 0;
    list-style-type: none;
    overflow: hidden;
    color: $text-color;
    &.show {
      height: calc(100% - 75px);
      // height: 100%;
      transition: height ease .6s;
    }
    .navLink {
      padding: 10px 40px;
      &:hover {
        background-color: $background-color;
        opacity: 0.5;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  a {
    padding: 8px 15px;
  }
}
@keyframes dropdown {
  0% {
    height: 0;
  }
  100% {
    height: auto;
  }
}

@media screen and (min-width: 992px){
  .navbar{
    display: none;
  }
  .navbar-button {
    display: none;
  }
}

@media screen and (max-width: 1200px){
  .header-title {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100vw;
    transform: translate(-50%, -50%);
  }
}

@media screen and (max-width: 991px){
  .header-container {
    display: none;
  }
}

@media screen and (max-width: 576px){
  .header-title {
    position: absolute;
    top: 40%;
    left: 50%;
    // width: 320px;
  }
}
</style>
